import Integration from "@/shared/components/ui/Connection/Integrations";
import SettingsCommonLayout from "./SettingsCommonLayout";

const IntegrationSettings = ({ tab }) => {
  return (
    <SettingsCommonLayout
      title="Connect your tools"
      description="Connect your communication tools to make every message count."
      tab={tab}
      saveButtonClick={{}}
      cancelButtonClick={{}}
    >
      <div className="mt-6">
        <Integration />
      </div>
    </SettingsCommonLayout>
  );
};

export default IntegrationSettings;
